import React from 'react';
import { FileText, HardHat } from 'lucide-react';
import { WorkerAnagrafica } from '../../types/worker';
import { formatItDate, getWorkerRuolo } from '../../utils/workers';
interface WorkerAnagraficaSectionsProps {
  worker: WorkerAnagrafica;
}
interface FieldProps {
  label: string;
  value?: string;
  mono?: boolean;
  full?: boolean;
}
function Field({
  label,
  value,
  mono = false,
  full = false
}: FieldProps) {
  return <div className={`space-y-1 ${full ? 'col-span-full' : ''}`} data-id="element-2179" data-mp="24c9whpapbu5f">
      <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-2180" data-mp="29bwe0axkbwk1">
        {label}
      </span>
      <p className={`font-medium ${mono ? 'font-mono' : ''}`} data-id="element-2181" data-mp="2eappxyx7bfi3">{value || '-'}</p>
    </div>;
}
export function WorkerAnagraficaSections({
  worker
}: WorkerAnagraficaSectionsProps) {
  return <div className="space-y-8" data-id="element-2182" data-mp="jxht61po0ttt">
      <section data-id="element-2183" data-mp="jyjdkwskmso7">
        <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-2184" data-mp="jz173lnumssf">
          <HardHat className="h-4 w-4" data-id="element-2185" data-mp="o0w96sdlta79" /> Dati personali
        </h4>
        <div className="grid grid-cols-2 gap-6" data-id="element-2186" data-mp="1v4tkcfls304r">
          <Field label="Nome e cognome" value={worker.name} full data-id="element-2187" data-mp="1qdbkxvzel7lw" />
          <Field label="Data di nascita" value={formatItDate(worker.birthDate)} data-id="element-2188" data-mp="1qc0ibzhp25wd" />
          <Field label="Città di nascita" value={worker.birthPlace} data-id="element-2189" data-mp="1lf0bhmd0sz47" />
          <Field label="Provincia di nascita" value={worker.birthProvince} data-id="element-2190" data-mp="1gfnlisqurbxe" />
          <Field label="Nazionalità" value={worker.nationality} data-id="element-2191" data-mp="2e2w1y9bzxusj" />
          <Field label="Codice Fiscale" value={worker.fiscalCode} mono data-id="element-2192" data-mp="2e24jm07ettk7" />
          <Field label="Email personale" value={worker.email} data-id="element-2193" data-mp="294un60llshmv" />
        </div>
      </section>

      <div className="h-px bg-slate-100" data-id="element-2194" data-mp="243orbtwnce94"></div>

      <section data-id="element-2195" data-mp="246jc5mjko132">
        <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-2196" data-mp="1z5n6b3fnu4v0">
          <FileText className="h-4 w-4" data-id="element-2197" data-mp="sq2tlkcq14bz" /> Rapporto di lavoro
        </h4>
        <div className="grid grid-cols-2 gap-6" data-id="element-2198" data-mp="sn6wtzcm0lp4">
          <Field label="Tipo di rapporto" value={worker.employmentType} data-id="element-2199" data-mp="npf6h9rm57n1" />
          <Field label="Tipo di contratto" value={worker.contractType} data-id="element-2200" data-mp="3bvvstpzwu2s4" />
          <Field label="Mansione" value={worker.role} data-id="element-2201" data-mp="3bukkrdzfm8v7" />
          <Field label="Reparto di lavoro" value={worker.department} data-id="element-2202" data-mp="3fwph4kh9ljlj" />
          <Field label="Sede" value={worker.sede} data-id="element-2203" data-mp="31yr3jharpr73" />
          <Field label="Ruolo" value={getWorkerRuolo(worker)} data-id="element-2204" data-mp="320bxb4p9d63w" />
        </div>
      </section>
    </div>;
}